import React from "react";

function FaqSearch({ value, onChange }) {
  return (
    <div className="faq-topics mb-20">
        <h3>Search FAQ</h3>

      <div className="widget-body">
        <input
          className="form-control"
          type="search"
          placeholder="Keyword in title or tutor"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
export default FaqSearch;
